import { SITE_URL } from "./jsonld";

/**
 * Default Open Graph / Twitter share card. Absolute URL on the canonical origin
 * (crawlers reject relative og:image and SVG). Pages pass a per-page `image` to
 * override; otherwise every shared link gets this branded card instead of a
 * blank unfurl. NOTE: this PNG is generated by a separate step.
 */
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og/emulator-arcade.png`;

/**
 * Shared social/open-graph meta tags. In React Router 7 a child route's `meta`
 * REPLACES the parent's (it does not merge), so tags declared once in
 * `root.tsx` (og:locale, theme-color, the share image) are dropped on every
 * page that defines its own `meta`. This helper carries them so they survive on
 * every route that spreads it.
 *
 * Per-route `{ title }`, `{ name: "description" }`, and `{ name: "keywords" }`
 * vary per page and stay inline at the call site; this helper does NOT emit
 * them. Routes spread the returned array into their `meta` array, e.g.:
 *   return [
 *     { title },
 *     { name: "description", content: description },
 *     { name: "keywords", content: "..." },
 *     ...socialMeta({ title, description, url }),
 *   ];
 */
export function socialMeta({
  title,
  description,
  url,
  image = DEFAULT_OG_IMAGE,
  imageAlt = "Emulator Arcade",
}: {
  title: string;
  description: string;
  url: string;
  image?: string;
  imageAlt?: string;
}) {
  return [
    { property: "og:type", content: "website" },
    { property: "og:url", content: url },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:site_name", content: "Emulator Arcade" },
    { property: "og:locale", content: "en_US" },
    { property: "og:image", content: image },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    { property: "og:image:alt", content: imageAlt },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
    { name: "twitter:image", content: image },
    { name: "theme-color", content: "#161719" },
    { tagName: "link", rel: "canonical", href: url },
  ];
}
